import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signIn } from "../firebase/firebase"; // 👈 Gọi API CapacitorHttp

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email || !email.includes("@")) {
      alert("📧 Vui lòng nhập email hợp lệ!");
      return;
    }

    if (!pass || pass.length < 6) {
      alert("🔒 Mật khẩu phải từ 6 ký tự trở lên.");
      return;
    }

    try {
      // 👉 Gọi CapacitorHttp login
      const res = await signIn(email, pass);

      if (res && res.idToken) {
        console.log("✅ Đăng nhập thành công:", res);

        // ✅ Lưu child_id vào localStorage
        localStorage.setItem("child_id", res.localId);

        alert("✅ Đăng nhập thành công!");
        navigate("/41-home"); 
      } else {
        throw new Error("Không nhận được idToken.");
      }
    } catch (err) {
      console.error("❌ Lỗi đăng nhập:", err);
      const errorMsg = err.message || err.errorMessage || "";

      if (errorMsg.includes("INVALID_EMAIL")) {
        alert("📧 Email không hợp lệ.");
      } else if (errorMsg.includes("EMAIL_NOT_FOUND")) {
        alert("❌ Không tìm thấy tài khoản. Vui lòng đăng ký.");
      } else if (errorMsg.includes("INVALID_PASSWORD")) {
        alert("🔐 Mật khẩu không đúng. Vui lòng thử lại.");
      } else {
        alert("❌ Đăng nhập thất bại: " + errorMsg);
      }
    }
  };

  const handleForgotPassword = async () => {
    alert("🔔 Tính năng Quên mật khẩu cần thêm API riêng (chưa làm ở phiên bản này).");
  };

  return (
    <div className="w-full flex flex-col gap-4 px-10">
      <input
        className="p-3 rounded-full border border-gray-300"
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <input
        className="p-3 rounded-full border border-gray-300"
        type="password"
        placeholder="Mật khẩu"
        value={pass}
        onChange={(e) => setPass(e.target.value)}
      />

      <div
        className="text-sm text-blue-500 cursor-pointer hover:underline self-end"
        onClick={handleForgotPassword}
      >
        Quên mật khẩu?
      </div>

      <button
        onClick={handleLogin}
        className="mt-2 p-3 rounded-full bg-gradient-to-r from-pink-400 to-orange-300 text-white font-semibold"
      >
        Đăng nhập
      </button>
    </div>
  );
};

export default LoginForm;